import { render, staticRenderFns } from "./AboutMembersIndex.vue?vue&type=template&id=02ada21c&"
import script from "./AboutMembersIndex.vue?vue&type=script&lang=js&"
export * from "./AboutMembersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports